// import React, { useState, useEffect, useCallback, useMemo } from "react";
// import { useDispatch } from 'react-redux';
// import {
//   BrowserRouter as Router,
//   Route,
//   Routes,
//   Navigate,
// } from "react-router-dom";

// // Pages
// import About from "./Pages/About";
// import Privacy from "./Pages/Privacy";
// import Terms from "./Pages/Terms";
// import Refund from "./Pages/Refund";
// import AdminSignin from "./components/TutorDashboard/Pages/adminSignIn";
// import AdminDashboard from "./components/AdminDashboard/pages/Dashboard";
// import { TutDashPass } from "./components/TutorDashboard/Components/tutDashPass";
// import ScrollToTopRoute from "./ScrollToTopRoute";
// import HomeChat from "./Pages/Home-chat";
// import Faq from "./Pages/Faq";
// import SignIn from "./Pages/SignIn";
// import SignUp from "./Pages/SignUp";
// import TutorSignIn from "./Pages/TutorSignin";
// import TutorSignUp from "./Pages/TutorSignup";
// import NotFound from "./Pages/404";
// import Dashboard from "./components/StudentDashboard/Pages/Dashboard_main";
// import TutorDashboard from "./components/TutorDashboard/Pages/Dashboard_main";
// import ForgetPass from "./Pages/ForgetPass";
// import Tutor_regForm from "./components/TutorDashboard/Components/RegistrationForm";
// import Music_Tutor_regForm from "./components/TutorDashboard/Components/MusicTutorRegForm";
// import InterviewForm from "./components/TutorDashboard/Components/interviewForm";
// import Tutor_exam from "./components/TutorDashboard/tutor_exam/tutorExamApp";
// import { ResetPass } from "./components/ResetPassword/ResetPass";
// import BPage from "./app/blog/page";
// import BDpage from "./app/blog/[postDetails]/page";
// import Service from "./Pages/Service";
// import Certif from "./Pages/Certif";
// import Routey from "./Route/LoginRoute.jsx";
// import Loader from './components/loader/Loader';
// import { verifyUser } from './redux/slice/authSlice';

// // Fallback Loader Component
// const FallbackLoader = () => (
//   <div
//     style={{
//       display: "flex",
//       justifyContent: "center",
//       alignItems: "center",
//       height: "100vh",
//       flexDirection: "column",
//       backgroundColor: "#f8f9fa",
//     }}
//   >
//     <div
//       style={{
//         border: "4px solid #f3f3f3",
//         borderTop: "4px solid #3498db",
//         borderRadius: "50%",
//         width: "50px",
//         height: "50px",
//         animation: "spin 1s linear infinite",
//       }}
//     ></div>
//     <p
//       style={{
//         marginTop: "20px",
//         fontSize: "16px",
//         color: "#666",
//         fontFamily: "Arial, sans-serif",
//       }}
//     >
//       Loading tutor data...
//     </p>
//     <style jsx>{`
//       @keyframes spin {
//         0% {
//           transform: rotate(0deg);
//         }
//         100% {
//           transform: rotate(360deg);
//         }
//       }
//     `}</style>
//   </div>
// );

// const App = () => {
//   const dispatch = useDispatch();
//   const [user, setUser] = useState(null);
//   const [tutor, setTutor] = useState(null);
//   const [admin, setAdmin] = useState(null);
//   const [isLoading, setIsLoading] = useState(true);
//   const [isVerifying, setIsVerifying] = useState(true);

//   // Function to parse localStorage data safely
//   const parseLocalStorageData = useCallback((key) => {
//     try {
//       const data = localStorage.getItem(key);
//       return data ? JSON.parse(data) : null;
//     } catch (error) {
//       console.error(`Error parsing localStorage data for key ${key}:`, error);
//       return null;
//     }
//   }, []);

//   // Function to load data from localStorage
//   const loadUserData = useCallback(() => {
//     const userData = parseLocalStorageData("user");
//     const tutorData = parseLocalStorageData("tutor");
//     const adminData = parseLocalStorageData("admin");

//     setUser(userData);
//     setTutor(tutorData);
//     setAdmin(adminData);

//     const shouldKeepLoading =
//       tutorData &&
//       tutorData.refreshToken &&
//       (!tutorData.saveTutor || !tutorData.saveTutor.tutor_type);

//     setIsLoading(shouldKeepLoading);
//   }, [parseLocalStorageData]);

//   // Handle localStorage changes from other tabs/windows
//   const handleStorageChange = useCallback(
//     (e) => {
//       if (e.key === "tutor" || e.key === "user" || e.key === "admin") {
//         loadUserData();
//       }
//     },
//     [loadUserData]
//   );

//   // Modern auth verification
//   useEffect(() => {
//     const checkAuth = async () => {
//       const authToken = localStorage.getItem('authToken');
//       if (authToken) {
//         try {
//           await dispatch(verifyUser()).unwrap();
//         } catch (error) {
//           localStorage.removeItem('authToken');
//         }
//       }
//       setIsVerifying(false);
//     };

//     checkAuth();
//   }, [dispatch]);

//   // Load data on component mount and set up listeners
//   useEffect(() => {
//     loadUserData();
//     window.addEventListener("storage", handleStorageChange);

//     const handleWindowFocus = () => {
//       loadUserData();
//     };

//     window.addEventListener("focus", handleWindowFocus);

//     return () => {
//       window.removeEventListener("storage", handleStorageChange);
//       window.removeEventListener("focus", handleWindowFocus);
//     };
//   }, [loadUserData, handleStorageChange]);

//   // Memoize the loading condition
//   const shouldShowLoader = useMemo(() => {
//     return (
//       isVerifying ||
//       isLoading ||
//       (tutor &&
//         tutor.refreshToken &&
//         (!tutor.saveTutor || !tutor.saveTutor.tutor_type))
//     );
//   }, [isVerifying, isLoading, tutor]);

//   if (shouldShowLoader) {
//     return <Loader /> || <FallbackLoader />;
//   }

//   // Helper functions
//   const getTutorType = () => {
//     return tutor?.saveTutor?.tutor_type?.trim().toLowerCase();
//   };

//   const isUserAuthenticated = () => {
//     return user && user.refreshToken;
//   };

//   const isTutorAuthenticated = () => {
//     return tutor && tutor.refreshToken;
//   };

//   const isAdminAuthenticated = () => {
//     return admin && admin.refreshToken;
//   };

//   return (
//     <Router>
//       <Routes>
//         {/* Home Route */}
//         <Route
//           path="/"
//           element={
//             isUserAuthenticated() ? (
//               <Navigate to="/dashboard" replace />
//             ) : (
//               <ScrollToTopRoute>
//                 <HomeChat />
//               </ScrollToTopRoute>
//             )
//           }
//         />

//         {/* Student Dashboard */}
//         <Route
//           path="/dashboard"
//           element={
//             isUserAuthenticated() ? (
//               <ScrollToTopRoute>
//                 <Dashboard />
//               </ScrollToTopRoute>
//             ) : (
//               <Navigate to="/SignIn" replace />
//             )
//           }
//         />

//         {/* Blog Routes - These must come BEFORE tutor_dashboard routes */}
//         <Route
//           path="/blog"
//           element={
//             <ScrollToTopRoute>
//               <BPage />
//             </ScrollToTopRoute>
//           }
//         />
//         <Route
//           path="/blog/:postDetails"
//           element={
//             <ScrollToTopRoute>
//               <BDpage />
//             </ScrollToTopRoute>
//           }
//         />

//         {/* Public Routes */}
//         <Route
//           path="/About"
//           element={
//             <ScrollToTopRoute>
//               <About />
//             </ScrollToTopRoute>
//           }
//         />
//         <Route
//           path="/privacyPolicy"
//           element={
//             <ScrollToTopRoute>
//               <Privacy />
//             </ScrollToTopRoute>
//           }
//         />
//         <Route
//           path="/termsConditions"
//           element={
//             <ScrollToTopRoute>
//               <Terms />
//             </ScrollToTopRoute>
//           }
//         />
//         <Route
//           path="/Faq"
//           element={
//             <ScrollToTopRoute>
//               <Faq />
//             </ScrollToTopRoute>
//           }
//         />
//         <Route
//           path="/refundPolicy"
//           element={
//             <ScrollToTopRoute>
//               <Refund />
//             </ScrollToTopRoute>
//           }
//         />
//         <Route
//           path="/services/:slug"
//           element={
//             <ScrollToTopRoute>
//               <Service />
//             </ScrollToTopRoute>
//           }
//         />
//         <Route
//           path="/schoolCertificate/svj34dwq7aga77gc1cyu34"
//           element={
//             <ScrollToTopRoute>
//               <Certif />
//             </ScrollToTopRoute>
//           }
//         />

//         {/* Authentication Routes */}
//         <Route
//           path="/SignIn"
//           element={
//             isUserAuthenticated() ? (
//               <Navigate to="/dashboard" replace />
//             ) : (
//               <ScrollToTopRoute>
//                 <SignIn />
//               </ScrollToTopRoute>
//             )
//           }
//         />
//         <Route
//           path="/SignUp"
//           element={
//             isUserAuthenticated() ? (
//               <Navigate to="/dashboard" replace />
//             ) : (
//               <ScrollToTopRoute>
//                 <SignUp />
//               </ScrollToTopRoute>
//             )
//           }
//         />
//         <Route
//           path="/forgot-pass"
//           element={
//             <ScrollToTopRoute>
//               <ForgetPass />
//             </ScrollToTopRoute>
//           }
//         />

//         {/* Tutor Authentication Routes */}
//         <Route
//           path="/tutorSignup"
//           element={
//             isTutorAuthenticated() ? (
//               <Navigate to="/tutor_dashboard" replace />
//             ) : (
//               <ScrollToTopRoute>
//                 <TutorSignUp />
//               </ScrollToTopRoute>
//             )
//           }
//         />
//         <Route
//           path="/tutorSignin"
//           element={
//             isTutorAuthenticated() ? (
//               <Navigate to="/tutor_dashboard" replace />
//             ) : (
//               <ScrollToTopRoute>
//                 <TutorSignIn />
//               </ScrollToTopRoute>
//             )
//           }
//         />

//         {/* Password Reset Routes */}
//         <Route
//           path="/reset-pwd/:id/:tutorId"
//           element={
//             <ScrollToTopRoute>
//               <ResetPass />
//             </ScrollToTopRoute>
//           }
//         />
//         <Route
//           path="/tutDash-pwd/:name/:email/:secret_id"
//           element={
//             <ScrollToTopRoute>
//               <TutDashPass />
//             </ScrollToTopRoute>
//           }
//         />

//         {/* Admin Routes */}
//         <Route
//           path="/admin/*"
//           element={
//             isAdminAuthenticated() ? (
//               <ScrollToTopRoute>
//                 <AdminDashboard />
//               </ScrollToTopRoute>
//             ) : (
//               <ScrollToTopRoute>
//                 <AdminSignin />
//               </ScrollToTopRoute>
//             )
//           }
//         />

//         {/* Tutor-specific Protected Routes */}
//         <Route
//           path="/tutor_regform"
//           element={
//             isTutorAuthenticated() ? (
//               getTutorType() === "academic" ? (
//                 <ScrollToTopRoute>
//                   <Tutor_regForm />
//                 </ScrollToTopRoute>
//               ) : getTutorType() === "music" ? (
//                 <ScrollToTopRoute>
//                   <Music_Tutor_regForm />
//                 </ScrollToTopRoute>
//               ) : (
//                 <Navigate to="/tutorSignin" replace />
//               )
//             ) : (
//               <Navigate to="/tutorSignin" replace />
//             )
//           }
//         />

//         <Route
//           path="/interview_registration"
//           element={
//             isTutorAuthenticated() ? (
//               <ScrollToTopRoute>
//                 <InterviewForm />
//               </ScrollToTopRoute>
//             ) : (
//               <Navigate to="/tutorSignin" replace />
//             )
//           }
//         />

//         <Route
//           path="/tutor_exam/*"
//           element={
//             isTutorAuthenticated() ? (
//               <ScrollToTopRoute>
//                 <Tutor_exam />
//               </ScrollToTopRoute>
//             ) : (
//               <Navigate to="/tutorSignin" replace />
//             )
//           }
//         />

//         {/* 
//           Tutor Dashboard Routes - This should be one of the LAST routes
//           The /* allows for nested routing within the Routey component
//         */}
//         <Route
//           path="/tutor_dashboard/*"
//           element={
//             <ScrollToTopRoute>
//               <Routey />
//             </ScrollToTopRoute>
//           }
//         />

//         {/* 404 fallback - This should be the VERY LAST route */}
//         <Route
//           path="*"
//           element={
//             <ScrollToTopRoute>
//               <NotFound />
//             </ScrollToTopRoute>
//           }
//         />
//       </Routes>
//     </Router>
//   );
// };

// export default App;


import React, { useState, useEffect, useCallback, useMemo } from "react";
import { useDispatch, useSelector } from 'react-redux';
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";

// Pages
import About from "./Pages/About";
import Privacy from "./Pages/Privacy";
import Terms from "./Pages/Terms";
import Refund from "./Pages/Refund";
import AdminSignin from "./components/TutorDashboard/Pages/adminSignIn";
import AdminDashboard from "./components/AdminDashboard/pages/Dashboard";
import { TutDashPass } from "./components/TutorDashboard/Components/tutDashPass";
import ScrollToTopRoute from "./ScrollToTopRoute";
import HomeChat from "./Pages/Home-chat";
import Faq from "./Pages/Faq";
import SignIn from "./Pages/SignIn";
import SignUp from "./Pages/SignUp";
import TutorSignIn from "./Pages/TutorSignin";
import TutorSignUp from "./Pages/TutorSignup";
import NotFound from "./Pages/404";
import Dashboard from "./components/StudentDashboard/Pages/Dashboard_main";
import ForgetPass from "./Pages/ForgetPass";
import Tutor_regForm from "./components/TutorDashboard/Components/RegistrationForm";
import Music_Tutor_regForm from "./components/TutorDashboard/Components/MusicTutorRegForm";
import InterviewForm from "./components/TutorDashboard/Components/interviewForm";
import Tutor_exam from "./components/TutorDashboard/tutor_exam/tutorExamApp";
import { ResetPass } from "./components/ResetPassword/ResetPass";
import BPage from "./app/blog/page";
import BDpage from "./app/blog/[postDetails]/page";
import Service from "./Pages/Service";
import Certif from "./Pages/Certif";

// Import corrected route files
import LoginRoutes from "./Route/LoginRoute.jsx"; // Your existing login routes
import Register from "./Pages/Register.jsx"; // Register page
import RegisterDashboard from "./Pages/RegisterDashboard.jsx"; // Register dashboard

import Loader from './components/loader/Loader';
import { verifyUser } from './redux/slice/authSlice';

// Protected Route Component for Register Dashboard
const RegisterProtectedRoute = ({ children }) => {
  const registerState = useSelector((state) => state.register);
  
  if (!registerState.isLoggedIn || !registerState.authToken) {
    return <Navigate to="/register" replace />;
  }
  
  return children;
};

// Fallback Loader Component (keep existing)
const FallbackLoader = () => (
  <div style={{
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    flexDirection: "column",
    backgroundColor: "#f8f9fa",
  }}>
    <div style={{
      border: "4px solid #f3f3f3",
      borderTop: "4px solid #3498db",
      borderRadius: "50%",
      width: "50px",
      height: "50px",
      animation: "spin 1s linear infinite",
    }}></div>
    <p style={{
      marginTop: "20px",
      fontSize: "16px",
      color: "#666",
      fontFamily: "Arial, sans-serif",
    }}>
      Loading tutor data...
    </p>
  </div>
);

const App = () => {
  // Keep all your existing state and functions
  const dispatch = useDispatch();
  const [user, setUser] = useState(null);
  const [tutor, setTutor] = useState(null);
  const [admin, setAdmin] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isVerifying, setIsVerifying] = useState(true);

  // Keep all your existing functions (parseLocalStorageData, loadUserData, etc.)
  const parseLocalStorageData = useCallback((key) => {
    try {
      const data = localStorage.getItem(key);
      return data ? JSON.parse(data) : null;
    } catch (error) {
      console.error(`Error parsing localStorage data for key ${key}:`, error);
      return null;
    }
  }, []);

  const loadUserData = useCallback(() => {
    const userData = parseLocalStorageData("user");
    const tutorData = parseLocalStorageData("tutor");
    const adminData = parseLocalStorageData("admin");

    setUser(userData);
    setTutor(tutorData);
    setAdmin(adminData);

    const shouldKeepLoading = tutorData && tutorData.refreshToken && (!tutorData.saveTutor || !tutorData.saveTutor.tutor_type);
    setIsLoading(shouldKeepLoading);
  }, [parseLocalStorageData]);

  const handleStorageChange = useCallback((e) => {
    if (e.key === "tutor" || e.key === "user" || e.key === "admin") {
      loadUserData();
    }
  }, [loadUserData]);

  // Modern auth verification
  useEffect(() => {
    const checkAuth = async () => {
      const authToken = localStorage.getItem('authToken');
      if (authToken) {
        try {
          await dispatch(verifyUser()).unwrap();
        } catch (error) {
          localStorage.removeItem('authToken');
        }
      }
      setIsVerifying(false);
    };

    checkAuth();
  }, [dispatch]);

  useEffect(() => {
    loadUserData();
    window.addEventListener("storage", handleStorageChange);

    const handleWindowFocus = () => {
      loadUserData();
    };

    window.addEventListener("focus", handleWindowFocus);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
      window.removeEventListener("focus", handleWindowFocus);
    };
  }, [loadUserData, handleStorageChange]);

  const shouldShowLoader = useMemo(() => {
    return (
      isVerifying ||
      isLoading ||
      (tutor && tutor.refreshToken && (!tutor.saveTutor || !tutor.saveTutor.tutor_type))
    );
  }, [isVerifying, isLoading, tutor]);

  if (shouldShowLoader) {
    return <Loader /> || <FallbackLoader />;
  }

  // Helper functions
  const getTutorType = () => {
    return tutor?.saveTutor?.tutor_type?.trim().toLowerCase();
  };

  const isUserAuthenticated = () => {
    return user && user.refreshToken;
  };

  const isTutorAuthenticated = () => {
    return tutor && tutor.refreshToken;
  };

  const isAdminAuthenticated = () => {
    return admin && admin.refreshToken;
  };

  return (
    <Router>
      <Routes>
        {/* Keep all your existing routes */}
        <Route path="/" element={
          isUserAuthenticated() ? (
            <Navigate to="/dashboard" replace />
          ) : (
            <ScrollToTopRoute>
              <HomeChat />
            </ScrollToTopRoute>
          )
        } />

        <Route path="/dashboard" element={
          isUserAuthenticated() ? (
            <ScrollToTopRoute>
              <Dashboard />
            </ScrollToTopRoute>
          ) : (
            <Navigate to="/SignIn" replace />
          )
        } />

        {/* All your existing public routes */}
        <Route path="/blog" element={<ScrollToTopRoute><BPage /></ScrollToTopRoute>} />
        <Route path="/blog/:postDetails" element={<ScrollToTopRoute><BDpage /></ScrollToTopRoute>} />
        <Route path="/About" element={<ScrollToTopRoute><About /></ScrollToTopRoute>} />
        <Route path="/privacyPolicy" element={<ScrollToTopRoute><Privacy /></ScrollToTopRoute>} />
        <Route path="/termsConditions" element={<ScrollToTopRoute><Terms /></ScrollToTopRoute>} />
        <Route path="/Faq" element={<ScrollToTopRoute><Faq /></ScrollToTopRoute>} />
        <Route path="/refundPolicy" element={<ScrollToTopRoute><Refund /></ScrollToTopRoute>} />
        <Route path="/services/:slug" element={<ScrollToTopRoute><Service /></ScrollToTopRoute>} />
        <Route path="/schoolCertificate/svj34dwq7aga77gc1cyu34" element={<ScrollToTopRoute><Certif /></ScrollToTopRoute>} />

        {/* Authentication Routes */}
        <Route path="/SignIn" element={
          isUserAuthenticated() ? (
            <Navigate to="/dashboard" replace />
          ) : (
            <ScrollToTopRoute><SignIn /></ScrollToTopRoute>
          )
        } />
        <Route path="/SignUp" element={
          isUserAuthenticated() ? (
            <Navigate to="/dashboard" replace />
          ) : (
            <ScrollToTopRoute><SignUp /></ScrollToTopRoute>
          )
        } />
        <Route path="/forgot-pass" element={<ScrollToTopRoute><ForgetPass /></ScrollToTopRoute>} />

        {/* Tutor Authentication Routes */}
        <Route path="/tutorSignup" element={
          isTutorAuthenticated() ? (
            <Navigate to="/tutor_dashboard" replace />
          ) : (
            <ScrollToTopRoute><TutorSignUp /></ScrollToTopRoute>
          )
        } />
        <Route path="/tutorSignin" element={
          isTutorAuthenticated() ? (
            <Navigate to="/tutor_dashboard" replace />
          ) : (
            <ScrollToTopRoute><TutorSignIn /></ScrollToTopRoute>
          )
        } />

        {/* Password Reset Routes */}
        <Route path="/reset-pwd/:id/:tutorId" element={<ScrollToTopRoute><ResetPass /></ScrollToTopRoute>} />
        <Route path="/tutDash-pwd/:name/:email/:secret_id" element={<ScrollToTopRoute><TutDashPass /></ScrollToTopRoute>} />

        {/* Admin Routes */}
        <Route path="/admin/*" element={
          isAdminAuthenticated() ? (
            <ScrollToTopRoute><AdminDashboard /></ScrollToTopRoute>
          ) : (
            <ScrollToTopRoute><AdminSignin /></ScrollToTopRoute>
          )
        } />

        {/* Tutor-specific Protected Routes */}
        <Route path="/tutor_regform" element={
          isTutorAuthenticated() ? (
            getTutorType() === "academic" ? (
              <ScrollToTopRoute><Tutor_regForm /></ScrollToTopRoute>
            ) : getTutorType() === "music" ? (
              <ScrollToTopRoute><Music_Tutor_regForm /></ScrollToTopRoute>
            ) : (
              <Navigate to="/tutorSignin" replace />
            )
          ) : (
            <Navigate to="/tutorSignin" replace />
          )
        } />

        <Route path="/interview_registration" element={
          isTutorAuthenticated() ? (
            <ScrollToTopRoute><InterviewForm /></ScrollToTopRoute>
          ) : (
            <Navigate to="/tutorSignin" replace />
          )
        } />

        <Route path="/tutor_exam/*" element={
          isTutorAuthenticated() ? (
            <ScrollToTopRoute><Tutor_exam /></ScrollToTopRoute>
          ) : (
            <Navigate to="/tutorSignin" replace />
          )
        } />

        {/* FIXED: Register Routes - Separate Registration System */}
        <Route path="/register" element={<ScrollToTopRoute><Register /></ScrollToTopRoute>} />
        <Route path="/register-dashboard" element={
          <RegisterProtectedRoute>
            <ScrollToTopRoute><RegisterDashboard /></ScrollToTopRoute>
          </RegisterProtectedRoute>
        } />
        <Route path="/register-dashboard/tutor_exam/*" element={
          <RegisterProtectedRoute>
            <ScrollToTopRoute><Tutor_exam /></ScrollToTopRoute>
          </RegisterProtectedRoute>
        } />

        {/* FIXED: Login Routes - Tutor Dashboard System */}
        <Route path="/tutor_dashboard/*" element={<ScrollToTopRoute><LoginRoutes /></ScrollToTopRoute>} />

        {/* 404 fallback */}
        <Route path="*" element={<ScrollToTopRoute><NotFound /></ScrollToTopRoute>} />
      </Routes>
    </Router>
  );
};

export default App;

